import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// UI
import Typography from '@material-ui/core/Typography';

// Style
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
    },
  };
};

class ErrorView extends PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  };

  render() {
    return (
      <div className={this.props.classes.root}>
        <Typography variant="h5">{'Yikes, an error occurred.'}</Typography>
        <Typography variant="body2">{'Try reloading the page, if the'}</Typography>
        <Typography variant="body2">{'issue persists then please contact us.'}</Typography>
      </div>
    );
  }
}

export default withStyles(styles)(ErrorView);
